import { getImagesByDPR } from './helpers';
import type { Img } from './types';

// * Формирует строку srcset с учетом DPR:
// * Объединяет srcset для разных DPR в одну строку
export function getSrcSetByDPR(sizesUsed: number[], sizesImages: Img[], maxDPR = 2) {
  const imagesByDPR = getImagesByDPR(sizesUsed, sizesImages, maxDPR);

  const srcsetArray = Object.keys(imagesByDPR).reduce((result: string[], DPR: string) => {
    result.push(
      imagesByDPR[DPR].map(
        (imageByDPR: Img) => `${imageByDPR.url} ${imageByDPR.width ? `${imageByDPR.width}w` : ''}`,
      ).join(', '),
    );

    return result;
  }, []);

  return [...new Set(srcsetArray.join(', ').split(', '))].join(', ');
}
